import * as React from 'react';
import debounce from 'lodash.debounce';

export const useBoundingClientRectListener = (ref: React.RefObject<HTMLElement>): DOMRectReadOnly | undefined => {
    const [dimensions, setDimensions] = React.useState<DOMRectReadOnly | undefined>(undefined);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (ref && ref.current) {
                setDimensions(ref.current.getBoundingClientRect());
            }
        }, 1);

        const resize = debounce(() => {
            if (ref && ref.current) {
                setDimensions(ref.current.getBoundingClientRect());
            }
        }, 250);

        window.addEventListener('resize', resize);

        return () => {
            clearTimeout(timeout);
            window.removeEventListener('resize', resize);
        };
    }, [ref]);

    return dimensions;
};
